import { css } from '@emotion/react';
import { Divider, Paper } from '@mui/material';
import { Box } from '@mui/system';
import { EventCard } from '@scorenco/components';
import { Types } from '@scorenco/core';

type NextTwoEventsProps = {
  events: Types.Competitions_Event_Detail[];
};

export const NextTwoEvents = ({ events }: NextTwoEventsProps) => {
  return (
    <Paper variant="bordered">
      {!events?.length && (
        <>
          <EventCard
            key="event-1"
            css={css`
              width: 100%;
            `}
          />
          <Divider
            sx={{
              width: 'calc(100% + 4rem)',
              marginBottom: '1rem',
              opacity: '0.6',
            }}
          />
          <EventCard
            key="event-2"
            css={css`
              width: 100%;
            `}
          />
        </>
      )}
      {events?.map((event, idx) => (
        <Box key={idx}>
          {idx !== 0 && (
            <Divider
              key={`divider-${idx}`}
              sx={{
                width: 'calc(100% + 4rem)',
                marginBottom: '1rem',
                transform: 'translateX(-2rem)',
                opacity: '0.6',
              }}
            />
          )}
          <EventCard
            key={`event-${idx}`}
            event={event}
            css={css`
              width: 100%;
            `}
          />
        </Box>
      ))}
    </Paper>
  );
};
